import {
  BETWEEN_SITE_CAR_BOOKINGS_FETCHING,
  BETWEEN_SITE_CAR_BOOKINGS_FAILED,
  BETWEEN_SITE_CAR_BOOKINGS_SUCCESS,
} from "../../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case BETWEEN_SITE_CAR_BOOKINGS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case BETWEEN_SITE_CAR_BOOKINGS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case BETWEEN_SITE_CAR_BOOKINGS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
